
import ICondition from "@/modules/RegistrationSurvey/ts/ICondition";
import IQuestionVariable from "@/modules/RegistrationSurvey/ts/IQuestionVariable";
import IValidator from "@/modules/RegistrationSurvey/ts/IValidator";

const REQUIRED_FIELDS = [
    'id',
    'data_variable',
];

const ALWAYS_REQUIRED_QUESTIONS = [
    'FIRST_NAME',
    'LAST_NAME',
    'EMAIL'
];

export default class Question {

    protected answer: any;
    public id: number;
    public data_variable: IQuestionVariable;
    public condition: ICondition | undefined;
    public condition_data_variable_id: number | undefined;
    public conditionally_hidden: boolean;
    public user_skipped: boolean;
    public is_processed: boolean;
    public url_param_name: string | null;
    public hide_question: boolean;


    public constructor(question: any) {

        if (!question) throw new Error("Question object null or undefined!");

        this.validateQuestionObject(question);

        this.id = question.id;
        this.conditionally_hidden = false;
        this.is_processed = false;
        this.user_skipped = false;
        this.data_variable = question.data_variable;
        this.answer = question.answer ?? null;
        this.condition = question.condition ?? null;
        this.condition_data_variable_id = question.condition_data_variable_id ?? null;
        this.url_param_name = question.url_param_name;
        this.hide_question = question.hide_question;
    }

    public getName() {
        return this.data_variable.name;
    }

    public isProcessed() {
        return this.is_processed;
    }

    public setProcessed() {
        this.is_processed = true;
    }

    public reset() {
        this.answer = null;
        this.is_processed = false;
        this.conditionally_hidden = false;
        this.user_skipped = false;
    }

    public setBacked() {
        this.is_processed = false;
    }

    public setAnswer(value: any) {
        this.answer = value;
        this.is_processed = true;
    }

    public getAnswer() {
        return this.answer;
    }

    public setUserSkipped(value: boolean) {
        this.user_skipped = value;
        this.is_processed = true;
    }

    public setConditionallyHidden(value: boolean) {
        this.conditionally_hidden = value;
        this.is_processed = true;
    }

    public isAnswerRequired(): boolean {
        return this.hasRequiredValidator();
    }

    public hasRequiredValidator() {
        if (ALWAYS_REQUIRED_QUESTIONS.includes(this.data_variable.name)) return true;
        if (this.data_variable.validators === null) return false;
        return !!this.data_variable.validators.find((validator: IValidator) => validator.type === 'required');
    }

    protected validateQuestionObject(question: Object) {
        REQUIRED_FIELDS.forEach(field => {
            if (!question.hasOwnProperty(field)) {
                throw new Error("Question object is missing field " + field);
            }
        });
    }
}
